export function transformData(inputData) {
  const fieldTypes = {
    country: "string",
    day: "timestamp",
    latitude: "real",
    longitude: "real",
    canTimestamp: "timestamp",
    gpsTimestamp: "timestamp",
    batterySoc: "real",
    odometer: "real",
  };

  const fields = inputData?.fields?.map((field) => ({
    name: field.name,
    format: field.format,
    type: fieldTypes[field.name] || "",
  }));

  const rows = inputData?.rows?.map((row) => {
    return fields.map((field) => {
      if (field.type === "timestamp" && field.name === "day") {
        return convertDateandTime(row.dpCreateAtTimestamp);
      } else if (field.type === "timestamp" && field.name !== "day") {
        return convertDateandTime(row[field.name]);
      } else if (field.name === "country") {
        return "India";
      } else {
        return row[field.name];
      }
    });
  });

  const transformedData = {
    fields,
    rows: rows,
  };

  return transformedData;
}

const convertDateandTime = (inputTimestamp) => {
  const dateObject = new Date(inputTimestamp);

  const year = dateObject.getUTCFullYear();
  const month = (dateObject.getUTCMonth() + 1).toString().padStart(2, "0");
  const day = dateObject.getUTCDate().toString().padStart(2, "0");
  const hours = dateObject.getUTCHours().toString().padStart(2, "0");
  const minutes = dateObject.getUTCMinutes().toString().padStart(2, "0");
  const seconds = dateObject.getUTCSeconds().toString().padStart(2, "0");

  const formattedTimestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  return formattedTimestamp;
};
export const filterDataWithCoordinates = (obj) => {
  const filteredRows = obj?.rows?.filter((row) => {
    const latitude =
      row[obj.fields.findIndex((field) => field.name === "latitude")];
    const longitude =
      row[obj.fields.findIndex((field) => field.name === "longitude")];

    return (
      typeof latitude === "number" &&
      !isNaN(latitude) &&
      typeof longitude === "number" &&
      !isNaN(longitude)
    );
  });

  if (filteredRows?.length === 0) {
    window.alert("No Data Found");
  }
  if (!filteredRows) {
    window.alert("No Data Found");

  }

  return {
    ...obj,
    rows: filteredRows,
  };
};
